export function textEllipsis(letterLimits = 9999, ellipsis = '...') {
    const string = this || '';
    if (!string)
        return '';
    if (string.length <= letterLimits)
        return string;
    return string.slice(0, letterLimits).concat(ellipsis);
}
//# sourceMappingURL=textEllipsis.js.map